import { useTranslation } from "@hireroo/i18n";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import * as React from "react";

export type RemoteInterviewReportProps = {
  AiEvaluation?: React.ReactNode;
  Playback: React.ReactNode;
};

const RemoteInterviewReport: React.FC<RemoteInterviewReportProps> = props => {
  const { t } = useTranslation();

  return (
    <Stack direction="column" spacing={3} p={3}>
      {props.AiEvaluation}
      <Stack>
        <Typography fontWeight={700}>{t("プレイバック")}</Typography>
        {props.Playback}
      </Stack>
    </Stack>
  );
};

RemoteInterviewReport.displayName = "RemoteInterviewReport";

export default RemoteInterviewReport;
